<template>
    <main class="flex-1 relative overflow-y-auto py-6 focus:outline-none" tabindex="0">
        <div class="flex min-h-full items-center justify-center px-8 py-16">
            <div class="w-full max-w-[28rem]">
                <h1 class="text-4xl font-semibold text-gray-900">{{ $t('This page could not be found') }}</h1>
                <p class="mt-4 text-[0.95rem] leading-[1.6] text-ink">
                    {{ $t('The page you requested is currently unavailable or no longer exists.') }}
                </p>
                <div class="mt-10">
                    <router-link
                        active-class=""
                        class="btn-stage-primary min-h-[3rem] justify-center !px-12"
                        exact-active-class=""
                        :to="homePath"
                    >
                        {{ $t('Go home') }}
                    </router-link>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import {customerHomePath, resolveStoreAccess} from "@/utils/access-context";

export default {
    name: "not-found",
    computed: {
        homePath() {
            return customerHomePath(resolveStoreAccess(this.$store));
        },
    },
    metaInfo() {
        return {
            title: this.$i18n.t('Not found')
        }
    },
}
</script>
